export default __webpack_public_path__ + "static/media/paint-05 (1).3e639453.jpg";